import i18n from 'i18next';
import { useEffect } from 'react';

import { useCustomTranslations } from '~/data/customTranslations/useCustomTranslations';

export function useInjectCustomTranslations(language: string | undefined) {
  const { customTranslations, hasData } = useCustomTranslations();

  useEffect(() => {
    if (!hasData || !language) return;

    const overrides = customTranslations[language] || {};
    // Inject custom translations for the current language
    if (Object.keys(overrides).length > 0) {
      i18n.addResourceBundle(
        language,
        'translation',
        overrides,
        true, // deep merge
        true, // overwrite
      );
    }
  }, [customTranslations, hasData, language]);
}
